var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "table" }, [
    _c(
      "div",
      { staticClass: "container" },
      [
        _c(
          "div",
          { staticClass: "handle-box" },
          [
            _c(
              "el-form",
              {
                ref: "queryCondition",
                staticClass: "searchForm",
                attrs: {
                  model: _vm.queryCondition,
                  "label-position": "right",
                  "label-width": "120px",
                },
              },
              [
                _c(
                  "el-row",
                  [
                    _c(
                      "el-col",
                      { attrs: { span: 24 } },
                      [
                        _c(
                          "el-row",
                          { attrs: { gutter: 20 } },
                          [
                            _c(
                              "el-col",
                              { attrs: { span: 6 } },
                              [
                                _c(
                                  "el-form-item",
                                  {
                                    attrs: {
                                      label: "检测窗口期",
                                      prop: "windowTimeList",
                                    },
                                  },
                                  [
                                    _c(
                                      "el-select",
                                      {
                                        staticClass: "multiple_sel",
                                        staticStyle: { width: "100%" },
                                        attrs: {
                                          clearable: "",
                                          multiple: "",
                                          filterable: "",
                                          placeholder: "请选择(支持多选)",
                                        },
                                        model: {
                                          value:
                                            _vm.queryCondition.windowTimeList,
                                          callback: function ($$v) {
                                            _vm.$set(
                                              _vm.queryCondition,
                                              "windowTimeList",
                                              $$v
                                            )
                                          },
                                          expression:
                                            "queryCondition.windowTimeList",
                                        },
                                      },
                                      _vm._l(
                                        _vm.windowTimeList,
                                        function (item) {
                                          return _c("el-option", {
                                            key: item.code,
                                            attrs: {
                                              label: item.name,
                                              value: item.code,
                                            },
                                          })
                                        }
                                      ),
                                      1
                                    ),
                                  ],
                                  1
                                ),
                              ],
                              1
                            ),
                            _c(
                              "el-col",
                              { attrs: { span: 6 } },
                              [
                                _c(
                                  "el-form-item",
                                  {
                                    attrs: {
                                      label: "数据查询范围",
                                      prop: "queryRange",
                                    },
                                  },
                                  [
                                    _c(
                                      "el-select",
                                      {
                                        staticClass: "multiple_sel",
                                        staticStyle: { width: "100%" },
                                        attrs: {
                                          clearable: "",
                                          placeholder: "最新全量数据",
                                        },
                                        on: { change: _vm.queryRangeChange },
                                        model: {
                                          value: _vm.queryCondition.queryRange,
                                          callback: function ($$v) {
                                            _vm.$set(
                                              _vm.queryCondition,
                                              "queryRange",
                                              $$v
                                            )
                                          },
                                          expression:
                                            "queryCondition.queryRange",
                                        },
                                      },
                                      _vm._l(
                                        _vm.queryRangeLists,
                                        function (item) {
                                          return _c("el-option", {
                                            key: item.code,
                                            attrs: {
                                              label: item.name,
                                              value: item.code,
                                            },
                                          })
                                        }
                                      ),
                                      1
                                    ),
                                  ],
                                  1
                                ),
                              ],
                              1
                            ),
                            _c(
                              "el-col",
                              { attrs: { span: 6 } },
                              [
                                _c(
                                  "el-form-item",
                                  {
                                    attrs: {
                                      label: "产品编码",
                                      prop: "fiveBitCode",
                                    },
                                  },
                                  [
                                    _c("el-input", {
                                      staticStyle: { width: "100%" },
                                      attrs: { clearable: "" },
                                      model: {
                                        value: _vm.queryCondition.fiveBitCode,
                                        callback: function ($$v) {
                                          _vm.$set(
                                            _vm.queryCondition,
                                            "fiveBitCode",
                                            $$v
                                          )
                                        },
                                        expression:
                                          "queryCondition.fiveBitCode",
                                      },
                                    }),
                                  ],
                                  1
                                ),
                              ],
                              1
                            ),
                            _c(
                              "el-col",
                              { attrs: { span: 6 } },
                              [
                                _c(
                                  "el-form-item",
                                  {
                                    attrs: {
                                      label: "产品中文名称",
                                      prop: "describe",
                                    },
                                  },
                                  [
                                    _c("el-input", {
                                      staticStyle: { width: "100%" },
                                      attrs: { clearable: "" },
                                      model: {
                                        value: _vm.queryCondition.describe,
                                        callback: function ($$v) {
                                          _vm.$set(
                                            _vm.queryCondition,
                                            "describe",
                                            $$v
                                          )
                                        },
                                        expression: "queryCondition.describe",
                                      },
                                    }),
                                  ],
                                  1
                                ),
                              ],
                              1
                            ),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                    _c(
                      "el-collapse-transition",
                      [
                        _vm.isShow
                          ? _c(
                              "el-col",
                              { attrs: { span: 24 } },
                              [
                                _c(
                                  "el-row",
                                  { attrs: { gutter: 20 } },
                                  [
                                    _c(
                                      "el-col",
                                      { attrs: { span: 6 } },
                                      [
                                        _c(
                                          "el-form-item",
                                          {
                                            attrs: {
                                              label: "产品英文名称",
                                              prop: "fiveBitCodeName",
                                            },
                                          },
                                          [
                                            _c("el-input", {
                                              staticStyle: { width: "100%" },
                                              attrs: { clearable: "" },
                                              model: {
                                                value:
                                                  _vm.queryCondition
                                                    .fiveBitCodeName,
                                                callback: function ($$v) {
                                                  _vm.$set(
                                                    _vm.queryCondition,
                                                    "fiveBitCodeName",
                                                    $$v
                                                  )
                                                },
                                                expression:
                                                  "queryCondition.fiveBitCodeName",
                                              },
                                            }),
                                          ],
                                          1
                                        ),
                                      ],
                                      1
                                    ),
                                    _c(
                                      "el-col",
                                      { attrs: { span: 6 } },
                                      [
                                        _c(
                                          "el-form-item",
                                          {
                                            attrs: {
                                              label: "Category2",
                                              prop: "categoryLevel2CodeList",
                                            },
                                          },
                                          [
                                            _c(
                                              "el-select",
                                              {
                                                staticClass: "multiple_sel",
                                                staticStyle: { width: "100%" },
                                                attrs: {
                                                  clearable: "",
                                                  multiple: "",
                                                  filterable: "",
                                                  placeholder:
                                                    "请选择(支持多选)",
                                                },
                                                on: {
                                                  change: _vm.changeCategory2,
                                                },
                                                model: {
                                                  value:
                                                    _vm.queryCondition
                                                      .categoryLevel2CodeList,
                                                  callback: function ($$v) {
                                                    _vm.$set(
                                                      _vm.queryCondition,
                                                      "categoryLevel2CodeList",
                                                      $$v
                                                    )
                                                  },
                                                  expression:
                                                    "queryCondition.categoryLevel2CodeList",
                                                },
                                              },
                                              _vm._l(
                                                _vm.categoryList2,
                                                function (item) {
                                                  return _c("el-option", {
                                                    key: item.code,
                                                    attrs: {
                                                      label: item.name,
                                                      value: item.code,
                                                    },
                                                  })
                                                }
                                              ),
                                              1
                                            ),
                                          ],
                                          1
                                        ),
                                      ],
                                      1
                                    ),
                                    _c(
                                      "el-col",
                                      { attrs: { span: 6 } },
                                      [
                                        _c(
                                          "el-form-item",
                                          {
                                            attrs: {
                                              label: "Category3",
                                              prop: "categoryLevel3CodeList",
                                            },
                                          },
                                          [
                                            _c(
                                              "el-select",
                                              {
                                                staticClass: "multiple_sel",
                                                staticStyle: { width: "100%" },
                                                attrs: {
                                                  clearable: "",
                                                  multiple: "",
                                                  filterable: "",
                                                  placeholder:
                                                    "请选择(支持多选)",
                                                },
                                                model: {
                                                  value:
                                                    _vm.queryCondition
                                                      .categoryLevel3CodeList,
                                                  callback: function ($$v) {
                                                    _vm.$set(
                                                      _vm.queryCondition,
                                                      "categoryLevel3CodeList",
                                                      $$v
                                                    )
                                                  },
                                                  expression:
                                                    "queryCondition.categoryLevel3CodeList",
                                                },
                                              },
                                              _vm._l(
                                                _vm.categoryList3,
                                                function (item) {
                                                  return _c("el-option", {
                                                    key: item.code,
                                                    attrs: {
                                                      label: item.name,
                                                      value: item.code,
                                                    },
                                                  })
                                                }
                                              ),
                                              1
                                            ),
                                          ],
                                          1
                                        ),
                                      ],
                                      1
                                    ),
                                    _c(
                                      "el-col",
                                      { attrs: { span: 6 } },
                                      [
                                        _c(
                                          "el-form-item",
                                          {
                                            attrs: {
                                              label: "结算单位名称",
                                              prop: "supplierName",
                                            },
                                          },
                                          [
                                            _c("el-input", {
                                              staticStyle: { width: "100%" },
                                              attrs: { clearable: "" },
                                              model: {
                                                value:
                                                  _vm.queryCondition
                                                    .supplierName,
                                                callback: function ($$v) {
                                                  _vm.$set(
                                                    _vm.queryCondition,
                                                    "supplierName",
                                                    $$v
                                                  )
                                                },
                                                expression:
                                                  "queryCondition.supplierName",
                                              },
                                            }),
                                          ],
                                          1
                                        ),
                                      ],
                                      1
                                    ),
                                  ],
                                  1
                                ),
                                _c(
                                  "el-row",
                                  { attrs: { gutter: 20 } },
                                  [
                                    _c(
                                      "el-col",
                                      { attrs: { span: 6 } },
                                      [
                                        _c(
                                          "el-form-item",
                                          {
                                            attrs: {
                                              label: "工厂名称",
                                              prop: "facilityName",
                                            },
                                          },
                                          [
                                            _c("el-input", {
                                              staticStyle: { width: "100%" },
                                              attrs: { clearable: "" },
                                              model: {
                                                value:
                                                  _vm.queryCondition
                                                    .facilityName,
                                                callback: function ($$v) {
                                                  _vm.$set(
                                                    _vm.queryCondition,
                                                    "facilityName",
                                                    $$v
                                                  )
                                                },
                                                expression:
                                                  "queryCondition.facilityName",
                                              },
                                            }),
                                          ],
                                          1
                                        ),
                                      ],
                                      1
                                    ),
                                    _c(
                                      "el-col",
                                      { attrs: { span: 6 } },
                                      [
                                        _c(
                                          "el-form-item",
                                          {
                                            attrs: {
                                              label: "检测原因",
                                              prop: "beSelectedReason",
                                            },
                                          },
                                          [
                                            _c("ic-select", {
                                              staticStyle: { width: "100%" },
                                              attrs: {
                                                table: "TT_NUTR_INSPECT",
                                                field: "BE_SELECTED_REASON",
                                                clearable: "",
                                              },
                                              model: {
                                                value:
                                                  _vm.queryCondition
                                                    .beSelectedReason,
                                                callback: function ($$v) {
                                                  _vm.$set(
                                                    _vm.queryCondition,
                                                    "beSelectedReason",
                                                    $$v
                                                  )
                                                },
                                                expression:
                                                  "queryCondition.beSelectedReason",
                                              },
                                            }),
                                          ],
                                          1
                                        ),
                                      ],
                                      1
                                    ),
                                    _c(
                                      "el-col",
                                      { attrs: { span: 6 } },
                                      [
                                        _c(
                                          "el-form-item",
                                          {
                                            attrs: {
                                              label: "烹饪方式",
                                              prop: "cookCode",
                                            },
                                          },
                                          [
                                            _c("ic-select", {
                                              staticStyle: { width: "100%" },
                                              attrs: {
                                                table: "TR_NUTR_GRI_COOK",
                                                field: "COOK_CODE",
                                                clearable: "",
                                              },
                                              model: {
                                                value:
                                                  _vm.queryCondition.cookCode,
                                                callback: function ($$v) {
                                                  _vm.$set(
                                                    _vm.queryCondition,
                                                    "cookCode",
                                                    $$v
                                                  )
                                                },
                                                expression:
                                                  "queryCondition.cookCode",
                                              },
                                            }),
                                          ],
                                          1
                                        ),
                                      ],
                                      1
                                    ),
                                    _c(
                                      "el-col",
                                      { attrs: { span: 6 } },
                                      [
                                        _c(
                                          "el-form-item",
                                          {
                                            attrs: {
                                              label: "更新日期倒序",
                                              prop: "sortByUpdate",
                                            },
                                          },
                                          [
                                            _c("el-checkbox", {
                                              model: {
                                                value:
                                                  _vm.queryCondition
                                                    .sortByUpdate,
                                                callback: function ($$v) {
                                                  _vm.$set(
                                                    _vm.queryCondition,
                                                    "sortByUpdate",
                                                    $$v
                                                  )
                                                },
                                                expression:
                                                  "queryCondition.sortByUpdate",
                                              },
                                            }),
                                          ],
                                          1
                                        ),
                                      ],
                                      1
                                    ),
                                  ],
                                  1
                                ),
                              ],
                              1
                            )
                          : _vm._e(),
                      ],
                      1
                    ),
                  ],
                  1
                ),
                _c(
                  "el-row",
                  {
                    attrs: { type: "flex", justify: "center", align: "middle" },
                  },
                  [
                    _c(
                      "el-button",
                      {
                        attrs: { size: "mini", type: "primary" },
                        on: { click: _vm.onSearch },
                      },
                      [_vm._v("查询")]
                    ),
                    _c(
                      "el-button",
                      {
                        attrs: { size: "mini", type: "primary" },
                        on: { click: _vm.onReset },
                      },
                      [_vm._v("重置")]
                    ),
                    _c(
                      "span",
                      {
                        staticClass: "arrowDown",
                        on: {
                          click: function ($event) {
                            _vm.isShow = !_vm.isShow
                          },
                        },
                      },
                      [
                        _vm._v(_vm._s(_vm.isShow ? "收缩" : "展开")),
                        _c("i", {
                          class: _vm.isShow
                            ? "el-icon-arrow-up iconBtn"
                            : "el-icon-arrow-down iconBtn",
                        }),
                      ]
                    ),
                  ],
                  1
                ),
              ],
              1
            ),
          ],
          1
        ),
        _c(
          "el-row",
          { staticClass: "action-btn-row" },
          [
            _c(
              "el-button",
              {
                directives: [
                  {
                    name: "acl",
                    rawName: "v-acl",
                    value: _vm.NUTRITION_INSPECT_ADD,
                    expression: "NUTRITION_INSPECT_ADD",
                  },
                ],
                staticClass: "btn",
                attrs: { size: "mini", type: "primary" },
                on: { click: _vm.onAdd },
              },
              [_vm._v("新增")]
            ),
            _c(
              "el-button",
              {
                directives: [
                  {
                    name: "acl",
                    rawName: "v-acl",
                    value: _vm.NUTRITION_INSPECT_DELETE,
                    expression: "NUTRITION_INSPECT_DELETE",
                  },
                ],
                staticClass: "btn",
                attrs: { size: "mini", type: "danger" },
                on: { click: _vm.onDel },
              },
              [_vm._v("删除")]
            ),
            _c(
              "el-button",
              {
                directives: [
                  {
                    name: "acl",
                    rawName: "v-acl",
                    value: _vm.NUTRITION_INSPECT_RESTORE,
                    expression: "NUTRITION_INSPECT_RESTORE",
                  },
                ],
                staticClass: "btn",
                attrs: {
                  size: "mini",
                  type: "primary",
                  disabled: _vm.isRDisabled,
                  loading: _vm.isRLoading,
                },
                on: { click: _vm.onRestore },
              },
              [_vm._v("恢复")]
            ),
            _c(
              "el-button",
              {
                directives: [
                  {
                    name: "acl",
                    rawName: "v-acl",
                    value: _vm.NUTRITION_INSPECT_CONFIRM,
                    expression: "NUTRITION_INSPECT_CONFIRM",
                  },
                ],
                staticClass: "btn",
                attrs: { size: "mini", type: "primary" },
                on: { click: _vm.onConfirm },
              },
              [_vm._v("确认检测范围")]
            ),
            _c(
              "el-button",
              {
                directives: [
                  {
                    name: "acl",
                    rawName: "v-acl",
                    value: _vm.NUTRITION_INSPECT_COPY_RESULT,
                    expression: "NUTRITION_INSPECT_COPY_RESULT",
                  },
                ],
                staticClass: "btn",
                attrs: { size: "mini", type: "primary" },
                on: { click: _vm.onCopy },
              },
              [_vm._v("复制检测结果")]
            ),
            _c(
              "el-button",
              {
                directives: [
                  {
                    name: "acl",
                    rawName: "v-acl",
                    value: _vm.NUTRITION_INSPECT_RELEASE,
                    expression: "NUTRITION_INSPECT_RELEASE",
                  },
                ],
                staticClass: "btn",
                attrs: {
                  size: "mini",
                  type: "primary",
                  disabled: _vm.isPDisabled,
                  loading: _vm.isPLoading,
                },
                on: { click: _vm.onPublish },
              },
              [_vm._v("发布")]
            ),
            _vm.isSubmit
              ? _c(
                  "el-button",
                  {
                    staticClass: "btn",
                    attrs: {
                      size: "mini",
                      type: "primary",
                      disabled: _vm.isSDisabled,
                      loading: _vm.isSLoading,
                    },
                    on: { click: _vm.onSubmit },
                  },
                  [_vm._v("提交")]
                )
              : _vm._e(),
            _c(
              "el-dropdown",
              {
                directives: [
                  {
                    name: "acl",
                    rawName: "v-acl",
                    value:
                      (_vm.NUTRITION_INSPECT_IMPORT_DATA,
                      _vm.NUTRITION_INSPECT_IMPORT_ATTACHMENT),
                    expression:
                      "NUTRITION_INSPECT_IMPORT_DATA,NUTRITION_INSPECT_IMPORT_ATTACHMENT",
                  },
                ],
                attrs: {
                  "split-button": "",
                  type: "primary",
                  placement: "bottom",
                },
                on: { click: _vm.handleClick },
              },
              [
                _vm._v(" 批量导入 "),
                _c(
                  "el-dropdown-menu",
                  { attrs: { slot: "dropdown" }, slot: "dropdown" },
                  [
                    _c(
                      "el-dropdown-item",
                      [
                        _c(
                          "el-button",
                          {
                            directives: [
                              {
                                name: "acl",
                                rawName: "v-acl",
                                value: _vm.NUTRITION_INSPECT_IMPORT_DATA,
                                expression: "NUTRITION_INSPECT_IMPORT_DATA",
                              },
                            ],
                            staticClass: "dropdownItemBtn",
                            attrs: { size: "mini", type: "primary" },
                            on: { click: _vm.onTestData },
                          },
                          [_vm._v("营养检测数据")]
                        ),
                      ],
                      1
                    ),
                    _c(
                      "el-dropdown-item",
                      [
                        _c(
                          "el-button",
                          {
                            directives: [
                              {
                                name: "acl",
                                rawName: "v-acl",
                                value: _vm.NUTRITION_INSPECT_IMPORT_ATTACHMENT,
                                expression:
                                  "NUTRITION_INSPECT_IMPORT_ATTACHMENT",
                              },
                            ],
                            staticClass: "dropdownItemBtn",
                            attrs: { size: "mini", type: "primary" },
                            on: { click: _vm.onTestFile },
                          },
                          [_vm._v("营养检测附件")]
                        ),
                      ],
                      1
                    ),
                  ],
                  1
                ),
              ],
              1
            ),
            _c(
              "el-button",
              {
                directives: [
                  {
                    name: "acl",
                    rawName: "v-acl",
                    value: _vm.NUTRITION_INSPECT_EXPORT,
                    expression: "NUTRITION_INSPECT_EXPORT",
                  },
                ],
                staticClass: "btn",
                attrs: { size: "mini", type: "primary" },
                on: { click: _vm.onExport },
              },
              [_vm._v("报表导出")]
            ),
          ],
          1
        ),
        _c(
          "el-row",
          [
            _c(
              "el-tabs",
              {
                attrs: { type: "border-card" },
                on: { "tab-click": _vm.handleClick },
                model: {
                  value: _vm.activeName,
                  callback: function ($$v) {
                    _vm.activeName = $$v
                  },
                  expression: "activeName",
                },
              },
              _vm._l(_vm.tabLists, function (item, index) {
                return _c(
                  "el-tab-pane",
                  { key: index, attrs: { name: item.key } },
                  [
                    _c("span", { attrs: { slot: "label" }, slot: "label" }, [
                      _vm._v(_vm._s(item.label) + _vm._s("(" + item.num + ")")),
                    ]),
                    _c(
                      "el-table",
                      {
                        staticStyle: { width: "100%" },
                        attrs: {
                          data: item.lists,
                          "max-height": "425",
                          border: "",
                          stripe: "",
                        },
                        on: { "selection-change": _vm.handleSelectionChange },
                      },
                      [
                        _c("el-table-column", {
                          attrs: {
                            type: "selection",
                            width: "55",
                            fixed: "left",
                          },
                        }),
                        _c("el-table-column", {
                          attrs: {
                            sortable: "",
                            "sort-method": (a, b) =>
                              _vm.sortMethods(a, b, "windowTime"),
                            "show-overflow-tooltip": "",
                            prop: "windowTime",
                            label: "检测窗口期",
                            width: "120",
                          },
                        }),
                        _c("el-table-column", {
                          attrs: {
                            sortable: "",
                            "sort-method": (a, b) =>
                              _vm.sortMethods(a, b, "versionText"),
                            "show-overflow-tooltip": "",
                            prop: "versionText",
                            label: "版本",
                            width: "90",
                          },
                        }),
                        _c("el-table-column", {
                          attrs: {
                            sortable: "",
                            "sort-method": (a, b) =>
                              _vm.sortMethods(a, b, "beSelectedReasonText"),
                            "show-overflow-tooltip": "",
                            prop: "beSelectedReasonText",
                            label: "检测原因",
                            width: "120",
                          },
                        }),
                        _c("el-table-column", {
                          attrs: {
                            sortable: "",
                            "sort-method": (a, b) =>
                              _vm.sortMethods(a, b, "fiveBitCode"),
                            "show-overflow-tooltip": "",
                            prop: "fiveBitCode",
                            label: "产品编码",
                            width: "150",
                          },
                        }),
                        _c("el-table-column", {
                          attrs: {
                            sortable: "",
                            "sort-method": (a, b) =>
                              _vm.sortMethods(a, b, "describe"),
                            "show-overflow-tooltip": "",
                            prop: "describe",
                            label: "产品中文名称",
                            width: "150",
                          },
                        }),
                        _c("el-table-column", {
                          attrs: {
                            sortable: "",
                            "sort-method": (a, b) =>
                              _vm.sortMethods(a, b, "fiveBitCodeName"),
                            "show-overflow-tooltip": "",
                            prop: "fiveBitCodeName",
                            label: "产品英文名称",
                            width: "150",
                          },
                        }),
                        _c("el-table-column", {
                          attrs: {
                            sortable: "",
                            "sort-method": (a, b) =>
                              _vm.sortMethods(a, b, "supplierName"),
                            "show-overflow-tooltip": "",
                            prop: "supplierName",
                            label: "结算单位名称",
                            width: "150",
                          },
                        }),
                        _c("el-table-column", {
                          attrs: {
                            sortable: "",
                            "sort-method": (a, b) =>
                              _vm.sortMethods(a, b, "facilityName"),
                            "show-overflow-tooltip": "",
                            prop: "facilityName",
                            label: "工厂名称",
                            width: "150",
                          },
                        }),
                        _c("el-table-column", {
                          attrs: {
                            sortable: "",
                            "sort-method": (a, b) =>
                              _vm.sortMethods(a, b, "categoryLevel2Name"),
                            "show-overflow-tooltip": "",
                            prop: "categoryLevel2Name",
                            label: "Category2",
                            width: "120",
                          },
                        }),
                        _c("el-table-column", {
                          attrs: {
                            sortable: "",
                            "sort-method": (a, b) =>
                              _vm.sortMethods(a, b, "categoryLevel3Name"),
                            "show-overflow-tooltip": "",
                            prop: "categoryLevel3Name",
                            label: "Category3",
                            width: "120",
                          },
                        }),
                        _c("el-table-column", {
                          attrs: {
                            sortable: "",
                            "sort-method": (a, b) =>
                              _vm.sortMethods(a, b, "cookCodeText"),
                            "show-overflow-tooltip": "",
                            prop: "cookCodeText",
                            label: "烹饪方式",
                            width: "90",
                          },
                        }),
                        _c("el-table-column", {
                          attrs: {
                            sortable: "",
                            "sort-method": (a, b) =>
                              _vm.sortMethods(a, b, "labCodeText"),
                            "show-overflow-tooltip": "",
                            prop: "labCodeText",
                            label: "检测实验室",
                            width: "130",
                          },
                        }),
                        _c("el-table-column", {
                          attrs: {
                            sortable: "",
                            "sort-method": (a, b) =>
                              _vm.sortMethods(a, b, "inspectStatusText"),
                            "show-overflow-tooltip": "",
                            prop: "inspectStatusText",
                            label: "状态",
                            width: "100",
                          },
                        }),
                        _c("el-table-column", {
                          attrs: {
                            sortable: "",
                            "sort-method": (a, b) =>
                              _vm.sortMethods(a, b, "deleteReason"),
                            "show-overflow-tooltip": "",
                            prop: "deleteReason",
                            label: "删除原因",
                            width: "150",
                          },
                        }),
                        _c("el-table-column", {
                          attrs: {
                            sortable: "",
                            "sort-method": (a, b) =>
                              _vm.sortMethods(a, b, "inspectEndDate"),
                            "show-overflow-tooltip": "",
                            prop: "inspectEndDate",
                            label: "检测截至日期",
                            width: "120",
                          },
                        }),
                        _c("el-table-column", {
                          attrs: {
                            sortable: "",
                            "sort-method": (a, b) =>
                              _vm.sortMethods(a, b, "updateByName"),
                            "show-overflow-tooltip": "",
                            prop: "updateByName",
                            label: "更新人",
                            width: "120",
                          },
                        }),
                        _c("el-table-column", {
                          attrs: {
                            sortable: "",
                            "sort-method": (a, b) =>
                              _vm.sortMethods(a, b, "updateDate"),
                            "show-overflow-tooltip": "",
                            prop: "updateDate",
                            label: "更新日期",
                            width: "150",
                          },
                        }),
                        _c("el-table-column", {
                          attrs: {
                            sortable: "",
                            "sort-method": (a, b) =>
                              _vm.sortMethods(a, b, "cqsSubmitByName"),
                            "show-overflow-tooltip": "",
                            prop: "cqsSubmitByName",
                            label: "提交人",
                            width: "120",
                          },
                        }),
                        _c("el-table-column", {
                          attrs: {
                            sortable: "",
                            "sort-method": (a, b) =>
                              _vm.sortMethods(a, b, "cqsSubmitDate"),
                            "show-overflow-tooltip": "",
                            prop: "cqsSubmitDate",
                            label: "提交日期",
                            width: "150",
                          },
                        }),
                        _c("el-table-column", {
                          attrs: {
                            label: "操作",
                            width: "180",
                            fixed: "right",
                          },
                          scopedSlots: _vm._u(
                            [
                              {
                                key: "default",
                                fn: function (scope) {
                                  return [
                                    _c(
                                      "el-button",
                                      {
                                        attrs: { type: "text", size: "small" },
                                        on: {
                                          click: function ($event) {
                                            return _vm.onView(scope.row)
                                          },
                                        },
                                      },
                                      [_vm._v("查看")]
                                    ),
                                    (_vm.isModify1 &&
                                      (scope.row.inspectStatus == "Released" ||
                                        scope.row.inspectStatus ==
                                          "Uploaded")) ||
                                    (_vm.isModify &&
                                      (scope.row.inspectStatus == "Uploaded" ||
                                        scope.row.inspectStatus == "Finalized"))
                                      ? _c(
                                          "el-button",
                                          {
                                            directives: [
                                              {
                                                name: "acl",
                                                rawName: "v-acl",
                                                value:
                                                  _vm.NUTRITION_INSPECT_SUBMIT,
                                                expression:
                                                  "NUTRITION_INSPECT_SUBMIT",
                                              },
                                            ],
                                            attrs: {
                                              type: "text",
                                              size: "small",
                                            },
                                            on: {
                                              click: function ($event) {
                                                return _vm.onEdit(scope.row)
                                              },
                                            },
                                          },
                                          [_vm._v("编辑")]
                                        )
                                      : _vm._e(),
                                    scope.row.inspectStatus == "WaitConfirm"
                                      ? _c(
                                          "el-button",
                                          {
                                            directives: [
                                              {
                                                name: "acl",
                                                rawName: "v-acl",
                                                value:
                                                  _vm.NUTRITION_INSPECT_EDIT_RESON,
                                                expression:
                                                  "NUTRITION_INSPECT_EDIT_RESON",
                                              },
                                            ],
                                            attrs: {
                                              type: "text",
                                              size: "small",
                                            },
                                            on: {
                                              click: function ($event) {
                                                return _vm.onMaintenance(
                                                  scope.row
                                                )
                                              },
                                            },
                                          },
                                          [_vm._v("检测原因维护")]
                                        )
                                      : _vm._e(),
                                  ]
                                },
                              },
                            ],
                            null,
                            true
                          ),
                        }),
                      ],
                      1
                    ),
                    _c(
                      "div",
                      { staticClass: "pagination" },
                      [
                        _c("el-pagination", {
                          attrs: {
                            "current-page": _vm.queryCondition.pageNum,
                            "page-sizes": _vm.pageSizeList,
                            "page-size": _vm.queryCondition.pageSize,
                            layout: _vm.pageLayout,
                            total: _vm.totalCount,
                            "page-count": _vm.pages,
                          },
                          on: {
                            "size-change": _vm.handleSizeChange,
                            "current-change": _vm.handleCurrentChange,
                          },
                        }),
                      ],
                      1
                    ),
                  ],
                  1
                )
              }),
              1
            ),
          ],
          1
        ),
        _c(
          "el-dialog",
          {
            staticClass: "fpa",
            attrs: {
              title: "检测原因维护",
              visible: _vm.dialogVisible1,
              width: "30%",
              "close-on-click-modal": false,
            },
            on: {
              "update:visible": function ($event) {
                _vm.dialogVisible1 = $event
              },
              close: _vm.onClose1,
            },
          },
          [
            _c(
              "el-form",
              {
                ref: "maintenanceForm",
                attrs: { model: _vm.maintenanceForm, "label-width": "100px" },
              },
              [
                _c(
                  "el-form-item",
                  { attrs: { label: "产品编码", prop: "fiveBitCode" } },
                  [
                    _c("el-input", {
                      attrs: { disabled: "" },
                      model: {
                        value: _vm.maintenanceForm.fiveBitCode,
                        callback: function ($$v) {
                          _vm.$set(_vm.maintenanceForm, "fiveBitCode", $$v)
                        },
                        expression: "maintenanceForm.fiveBitCode",
                      },
                    }),
                  ],
                  1
                ),
                _c(
                  "el-form-item",
                  { attrs: { label: "产品中文名称", prop: "fiveBitCodeName" } },
                  [
                    _c("el-input", {
                      attrs: { disabled: "" },
                      model: {
                        value: _vm.maintenanceForm.fiveBitCodeName,
                        callback: function ($$v) {
                          _vm.$set(_vm.maintenanceForm, "fiveBitCodeName", $$v)
                        },
                        expression: "maintenanceForm.fiveBitCodeName",
                      },
                    }),
                  ],
                  1
                ),
                _c(
                  "el-form-item",
                  { attrs: { label: "工厂名称", prop: "facilityName" } },
                  [
                    _c("el-input", {
                      attrs: { disabled: "" },
                      model: {
                        value: _vm.maintenanceForm.facilityName,
                        callback: function ($$v) {
                          _vm.$set(_vm.maintenanceForm, "facilityName", $$v)
                        },
                        expression: "maintenanceForm.facilityName",
                      },
                    }),
                  ],
                  1
                ),
                _c(
                  "el-form-item",
                  {
                    attrs: {
                      label: "检测原因",
                      prop: "inspectReason",
                      rules: {
                        required: true,
                        message: "检测原因不能为空",
                        trigger: "change",
                      },
                    },
                  },
                  [
                    _c("ic-select", {
                      staticStyle: { width: "100%" },
                      attrs: {
                        table: "TT_NUTR_INSPECT",
                        field: "BE_SELECTED_REASON",
                        clearable: "",
                      },
                      model: {
                        value: _vm.maintenanceForm.inspectReason,
                        callback: function ($$v) {
                          _vm.$set(_vm.maintenanceForm, "inspectReason", $$v)
                        },
                        expression: "maintenanceForm.inspectReason",
                      },
                    }),
                  ],
                  1
                ),
              ],
              1
            ),
            _c(
              "el-row",
              {
                staticStyle: { "margin-top": "10px" },
                attrs: { type: "flex", justify: "center" },
              },
              [
                _c(
                  "el-button",
                  {
                    staticClass: "btn",
                    attrs: {
                      size: "mini",
                      type: "primary",
                      disabled: _vm.isSaveDisabled,
                      loading: _vm.isSaveLoading,
                    },
                    on: { click: _vm.onSaveMain },
                  },
                  [_vm._v("保存")]
                ),
                _c(
                  "el-button",
                  {
                    staticClass: "btn",
                    attrs: { size: "mini" },
                    on: { click: _vm.onClose1 },
                  },
                  [_vm._v("取消")]
                ),
              ],
              1
            ),
          ],
          1
        ),
        _c(
          "el-dialog",
          {
            staticClass: "fpa",
            attrs: {
              title: "选择复制检测结果",
              visible: _vm.dialogVisible3,
              width: "50%",
              "close-on-click-modal": false,
            },
            on: {
              "update:visible": function ($event) {
                _vm.dialogVisible3 = $event
              },
              close: _vm.onClose3,
            },
          },
          [
            _c(
              "el-table",
              {
                ref: "singleTable",
                staticStyle: { width: "100%" },
                attrs: { data: _vm.testData },
              },
              [
                _c("el-table-column", {
                  attrs: { width: "55" },
                  scopedSlots: _vm._u([
                    {
                      key: "default",
                      fn: function (scope) {
                        return [
                          _c(
                            "el-radio",
                            {
                              attrs: { label: scope.row },
                              model: {
                                value: _vm.selectOneData,
                                callback: function ($$v) {
                                  _vm.selectOneData = $$v
                                },
                                expression: "selectOneData",
                              },
                            },
                            [_vm._v(_vm._s(scope.row.name))]
                          ),
                        ]
                      },
                    },
                  ]),
                }),
                _c("el-table-column", {
                  attrs: {
                    prop: "windowTime",
                    label: "窗口期",
                    "min-width": "120",
                  },
                }),
                _c("el-table-column", {
                  attrs: {
                    prop: "versionText",
                    label: "版本",
                    "min-width": "100",
                  },
                }),
                _c("el-table-column", {
                  attrs: {
                    prop: "fiveBitCodeName",
                    label: "产品名称",
                    "min-width": "150",
                    "show-overflow-tooltip": "",
                  },
                }),
                _c("el-table-column", {
                  attrs: {
                    prop: "facilityName",
                    label: "工厂名称",
                    "min-width": "150",
                    "show-overflow-tooltip": "",
                  },
                }),
                _c("el-table-column", {
                  attrs: {
                    prop: "cookCodeText",
                    label: "烹饪方式",
                    "min-width": "150",
                    "show-overflow-tooltip": "",
                  },
                }),
              ],
              1
            ),
            _c(
              "el-row",
              {
                staticStyle: { "margin-top": "10px" },
                attrs: { type: "flex", justify: "center" },
              },
              [
                _c(
                  "el-button",
                  {
                    staticClass: "btn",
                    attrs: {
                      size: "mini",
                      type: "primary",
                      disabled: _vm.isCDisabled,
                      loading: _vm.isCLoading,
                    },
                    on: { click: _vm.onSaveCopy },
                  },
                  [_vm._v("确认")]
                ),
                _c(
                  "el-button",
                  {
                    staticClass: "btn",
                    attrs: { size: "mini" },
                    on: { click: _vm.onClose3 },
                  },
                  [_vm._v("关闭")]
                ),
              ],
              1
            ),
          ],
          1
        ),
        _c(
          "el-dialog",
          {
            staticClass: "fpa",
            attrs: {
              title: "检测数据范围",
              visible: _vm.dialogVisible4,
              width: "30%",
              "close-on-click-modal": false,
            },
            on: {
              "update:visible": function ($event) {
                _vm.dialogVisible4 = $event
              },
              close: _vm.onClose4,
            },
          },
          [
            _c(
              "el-form",
              {
                ref: "rangeForm",
                staticClass: "user_table",
                attrs: { model: _vm.rangeForm, "label-width": "100px" },
              },
              [
                _c("h4", [_vm._v("请确认本次检测窗口期的数据范围：")]),
                _c(
                  "el-form-item",
                  { attrs: { label: "检测窗口期:", prop: "windowTime" } },
                  [_c("span", [_vm._v(_vm._s(_vm.rangeForm.windowTime))])]
                ),
                _c(
                  "el-form-item",
                  { attrs: { label: "Category:", prop: "category" } },
                  [_c("span", [_vm._v(_vm._s(_vm.rangeForm.category))])]
                ),
                _c(
                  "el-form-item",
                  { attrs: { label: "检测数据:", prop: "inspectCount" } },
                  [
                    _c("span", [
                      _vm._v(_vm._s(_vm.rangeForm.inspectCount) + "条"),
                    ]),
                  ]
                ),
              ],
              1
            ),
            _c(
              "el-row",
              {
                staticStyle: { "margin-top": "10px" },
                attrs: { type: "flex", justify: "center" },
              },
              [
                _c(
                  "el-button",
                  {
                    staticClass: "btn",
                    attrs: {
                      size: "mini",
                      type: "primary",
                      disabled: _vm.isConfirmDisabled,
                      loading: _vm.isConfirmLoading,
                    },
                    on: { click: _vm.onSaveData },
                  },
                  [_vm._v("确认")]
                ),
                _c(
                  "el-button",
                  {
                    staticClass: "btn",
                    attrs: { size: "mini" },
                    on: { click: _vm.onClose4 },
                  },
                  [_vm._v("取消")]
                ),
              ],
              1
            ),
          ],
          1
        ),
        _c(
          "el-dialog",
          {
            staticClass: "fpa",
            attrs: {
              title: "批量导入",
              visible: _vm.dialogVisible5,
              width: "30%",
              "close-on-click-modal": false,
            },
            on: {
              "update:visible": function ($event) {
                _vm.dialogVisible5 = $event
              },
              close: _vm.onClose5,
            },
          },
          [
            _c(
              "el-row",
              { attrs: { type: "flex", justify: "start" } },
              [
                _c(
                  "el-upload",
                  {
                    ref: "upload",
                    attrs: {
                      name: "file",
                      action: "",
                      "http-request": _vm.httpRequest,
                      "show-file-list": false,
                    },
                  },
                  [
                    _c(
                      "el-button",
                      { attrs: { size: "small", type: "primary" } },
                      [_vm._v("选择文件")]
                    ),
                  ],
                  1
                ),
                _vm.flag == "data"
                  ? _c(
                      "el-button",
                      {
                        staticClass: "btn",
                        staticStyle: { "margin-left": "10px!important" },
                        attrs: { size: "mini", type: "primary" },
                        on: { click: _vm.onDownloadTem },
                      },
                      [_vm._v("导入模板下载")]
                    )
                  : _vm._e(),
                _vm.flag == "file"
                  ? _c(
                      "el-button",
                      {
                        staticClass: "btn",
                        staticStyle: { "margin-left": "10px!important" },
                        attrs: { size: "mini", type: "primary" },
                        on: { click: _vm.onDownloadName },
                      },
                      [_vm._v("附件命名模板下载")]
                    )
                  : _vm._e(),
              ],
              1
            ),
            _c(
              "el-row",
              { staticStyle: { "margin-top": "8px" } },
              [
                _c("el-input", {
                  attrs: { disabled: "" },
                  model: {
                    value: _vm.fileName,
                    callback: function ($$v) {
                      _vm.fileName = $$v
                    },
                    expression: "fileName",
                  },
                }),
              ],
              1
            ),
            _c("el-row", { staticStyle: { "margin-top": "8px" } }, [
              _vm.flag == "data"
                ? _c("ul", [
                    _c(
                      "li",
                      {
                        staticStyle: {
                          "font-size": "16px",
                          "font-weight": "600",
                          color: "red",
                        },
                      },
                      [_vm._v("说明:")]
                    ),
                    _c("li", { staticStyle: { color: "red" } }, [
                      _vm._v("1.请点击模板下载,按照模板填写后再上传"),
                    ]),
                    _c("li", { staticStyle: { color: "red" } }, [
                      _vm._v("2.模板中红色字段为必填项,请务必正确填写"),
                    ]),
                    _c("li", { staticStyle: { color: "red" } }, [
                      _vm._v("3.仅支持上传Excel格式文件,且大小不能超过20M"),
                    ]),
                    _c("li", { staticStyle: { color: "red" } }, [
                      _vm._v("4.为保证上传成功,请勿对模板中的单元格进行修改"),
                    ]),
                    _c("li", { staticStyle: { color: "red" } }, [
                      _vm._v(
                        "5.一次仅支持一份文件上传,多份文件上传将会替换原文件"
                      ),
                    ]),
                  ])
                : _vm._e(),
              _vm.flag == "file"
                ? _c("ul", [
                    _c(
                      "li",
                      {
                        staticStyle: {
                          "font-size": "16px",
                          "font-weight": "600",
                          color: "red",
                        },
                      },
                      [_vm._v("说明:")]
                    ),
                    _c("li", { staticStyle: { color: "red" } }, [
                      _vm._v("1.附件请按照命名模板重命名"),
                    ]),
                  ])
                : _vm._e(),
            ]),
            _c(
              "el-row",
              {
                staticStyle: { "margin-top": "10px" },
                attrs: { type: "flex", justify: "center" },
              },
              [
                _c(
                  "el-button",
                  {
                    staticClass: "btn",
                    attrs: { size: "mini", type: "primary" },
                    on: { click: _vm.onUpload },
                  },
                  [_vm._v("上传")]
                ),
                _c(
                  "el-button",
                  {
                    staticClass: "btn",
                    attrs: { size: "mini" },
                    on: { click: _vm.onClose5 },
                  },
                  [_vm._v("关闭")]
                ),
              ],
              1
            ),
          ],
          1
        ),
        _c(
          "el-dialog",
          {
            staticClass: "fpa",
            attrs: {
              title: "Ingredient主数据",
              visible: _vm.dialogVisible6,
              width: "80%",
              "close-on-click-modal": false,
            },
            on: {
              "update:visible": function ($event) {
                _vm.dialogVisible6 = $event
              },
              close: _vm.closeAdd,
            },
          },
          [
            _c("ingredientDialog", {
              attrs: { addInfo: _vm.addInfo },
              on: { closeAdd: _vm.closeAdd, setParam: _vm.setParam },
            }),
          ],
          1
        ),
        _c(
          "el-dialog",
          {
            staticClass: "fpa",
            attrs: {
              title: "删除原因",
              visible: _vm.dialogVisible7,
              width: "30%",
              "close-on-click-modal": false,
            },
            on: {
              "update:visible": function ($event) {
                _vm.dialogVisible7 = $event
              },
              close: _vm.onCloseDel,
            },
          },
          [
            _c(
              "el-form",
              {
                ref: "delForm",
                attrs: {
                  model: _vm.delForm,
                  rules: _vm.delRules,
                  "label-width": "70px",
                },
              },
              [
                _c(
                  "el-form-item",
                  { attrs: { label: "删除原因", prop: "deleteReason" } },
                  [
                    _c("el-input", {
                      attrs: { type: "textarea", rows: 4 },
                      model: {
                        value: _vm.delForm.deleteReason,
                        callback: function ($$v) {
                          _vm.$set(_vm.delForm, "deleteReason", $$v)
                        },
                        expression: "delForm.deleteReason",
                      },
                    }),
                  ],
                  1
                ),
              ],
              1
            ),
            _c(
              "el-row",
              {
                staticStyle: { "margin-top": "10px" },
                attrs: { type: "flex", justify: "center" },
              },
              [
                _c(
                  "el-button",
                  {
                    staticClass: "btn",
                    attrs: {
                      size: "mini",
                      type: "primary",
                      disabled: _vm.isDelDisabled,
                      loading: _vm.isDelLoading,
                    },
                    on: { click: _vm.onSaveDel },
                  },
                  [_vm._v("保存")]
                ),
                _c(
                  "el-button",
                  {
                    staticClass: "btn",
                    attrs: { size: "mini" },
                    on: { click: _vm.onCloseDel },
                  },
                  [_vm._v("取消")]
                ),
              ],
              1
            ),
          ],
          1
        ),
      ],
      1
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }